module.exports = __webpack_public_path__ + "img/ring_r_e_null_1@2x.2252b49a.png";